import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import CzGlobals from '../../global';

class SelectTipoDocumento extends PureComponent { 
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      allData: null, 
      hasError: false,
    };

    if (props.onChange) {
      this.onChange = props.onChange;
    };

  } 

  fetchAllData = () => {
    fetch(CzGlobals.apisite + 'JSONTipiDocumento.php')
      .then(response => response.json())
      .then(data => {
        console.log(data);
        this.setState({ allData: data, loading: false });

      }).catch(err => console.log(err));
  }

  

  componentWillMount = () => {
    console.log('SelectTipoDocumento will mount');
  }

  componentDidMount = () => {
    this.fetchAllData();
  }

  componentWillReceiveProps = (nextProps) => {
    console.log('SelectTipoDocumento will receive props', nextProps);
  }

  componentWillUpdate = (nextProps, nextState) => {
    console.log('SelectTipoDocumento will update', nextProps, nextState);
  }

  componentDidUpdate = () => {
    console.log('SelectTipoDocumento did update');
  }

  componentWillUnmount = () => {
    console.log('SelectTipoDocumento will unmount');
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong.</h1>;
    }

    if (this.state.loading) {
      return (<Form.Control as="select" defaultValue="Choose..." onChange={this.onChange} ></Form.Control>);
    }

    if (this.state.allData) {
    return (
      <div className="SelectTipoDocumentoWrapper">
      

      <Form.Control as="select" defaultValue="Choose..." onChange={this.onChange} >
      { this.state.allData.map((row) => { 
       return (<option value={row.id_doc}>{row.des_doc}</option>) })}
      
      </Form.Control>
       
      </div>
        )
      }
    
    }

}

SelectTipoDocumento.propTypes = {
  // bla: PropTypes.string,
};

SelectTipoDocumento.defaultProps = {
  // bla: 'test',
};

export default SelectTipoDocumento;
